















import { getProductsForBlock } from '~/services/get-products.coffee'

export default
	name: 'ProductCarousel'

	props: block: Object

	#If there's a list of products inlcuded
	data: ->
		products: [...@block.products]
		slidesToShow:
			desktopUp: 4
			desktopDown: 4
			tabletLandscapeDown: 3
			tabletDown: 2
			mobileLandscapeDown: 2
			mobileDown: 1


	# Fetch products
	fetch: ->
		newProducts = await getProductsForBlock @block
		@products = [
			...@products
			...newProducts
		]

